import {
  Box,
  Grid,
  makeStyles,
  Typography,
  Link,
  Chip,
  Tooltip,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from '@material-ui/core';
import { Link as RouterLink } from 'react-router-dom';
import { IContact } from 'app/models/responses/IContact';
import { ExceptionHandler } from 'components';
import { ConfirmationModal, GenericAvatar } from 'components/_dashboard';
import { useSnackbar } from 'notistack';
import React, { useState } from 'react';
import axios from 'utils/axios';
import clsx from 'clsx';
import DeleteIcon from '@material-ui/icons/Delete';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import PropertyList from 'components/_dashboard/PropertyList/PropertyList';
import PropertyListItem from 'components/_dashboard/PropertyListItem/PropertyListItem';
import { IClient } from 'app/models/responses/IClient';
import { IHostSite } from 'app/models/responses/IHostSite';
import { ISeta } from 'app/models/responses/ISeta';

const useStyles = makeStyles((theme) => ({
  root: {
    borderColor: theme.palette.divider,
    borderRadius: theme.shape.borderRadius,
    borderStyle: 'solid',
    borderWidth: 1,
    padding: theme.spacing(4, 3),
  },

  chip: {},
}));

interface IProps {
  contactPerson: IContact;
  onDelete: () => void;
  parentEntity: IClient | IHostSite | ISeta;
}

const ContactPerson: React.FC<IProps> = (props: IProps) => {
  const { contactPerson, onDelete, parentEntity } = props;
  const { enqueueSnackbar } = useSnackbar();
  const classes = useStyles();
  const [confirmDeleteOpen, setConfirmDeleteOpen] = useState(false);
  const [detailOpen, setDetailOpen] = useState(false);

  const handleDelete = () => {
    setConfirmDeleteOpen(false);
    onDelete();
  };

  return (
    <Grid item sm={6} xs={12}>
      <Box className={classes.root}>
        <Box
          style={{
            alignItems: 'center',
            display: 'flex',
          }}
        >
          <GenericAvatar name={contactPerson.userName!} avatarFile={contactPerson.avatarFileItem} />
          <Box sx={{ ml: 2 }}>
            <Tooltip title={'View Details'} placement='top'>
              <Typography
                color='textPrimary'
                component={Link}
                variant='subtitle2'
                style={{ cursor: 'pointer' }}
                onClick={() => setDetailOpen(true)}
              >
                {contactPerson.fullName}
              </Typography>
            </Tooltip>
            <Typography
              color='textSecondary'
              variant='body2'
              style={{ wordWrap: 'break-word', wordBreak: 'break-word' }}
            >
              {contactPerson.email}
            </Typography>
            {parentEntity.primaryContactId === contactPerson.id && (
              <Chip color='secondary' size='small' label='Key Contact' />
            )}
          </Box>
          <Box flexGrow={1} />
          <Tooltip title='Remove'>
            <IconButton onClick={() => setConfirmDeleteOpen(true)}>
              <DeleteIcon />
            </IconButton>
          </Tooltip>
        </Box>
      </Box>
      <ConfirmationModal
        open={confirmDeleteOpen}
        title='Remove Contact Person'
        message='Are you sure you wish to remove this person as a contact?'
        onCancel={() => setConfirmDeleteOpen(false)}
        onConfirm={handleDelete}
        error={true}
      />
      <Dialog open={detailOpen} onClose={() => setDetailOpen(false)}>
        <DialogTitle>
          <Box display='flex' style={{ gap: 2 }}>
            <Typography color='textPrimary' variant='h5'>
              {contactPerson.fullName}
            </Typography>
            <Box flexGrow={1} />
            <Button
              color='secondary'
              variant='outlined'
              component={RouterLink}
              to={`/training/contacts/${contactPerson.id}`}
              startIcon={<AccountCircleIcon />}
            >
              Profile
            </Button>
          </Box>
        </DialogTitle>
        <DialogContent>
          <PropertyList>
            <PropertyListItem label='Username' align='horizontal' value={contactPerson.userName} />
            <PropertyListItem
              label='Email Address'
              align='horizontal'
              value={contactPerson.email}
            />
            <PropertyListItem
              label='Cell Number'
              align='horizontal'
              value={contactPerson.contactInfo?.cellNumber || '-'}
            />
          </PropertyList>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDetailOpen(false)} color='primary' variant='outlined'>
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </Grid>
  );
};

export default ContactPerson;
